import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page45() {
  useEffect(() => {
    document.title = "Маяк — Страница 44"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page43" />
        <ForwardLink href="/page45" />
      </div>

      <p style={{ textAlign: "right" }}>44.</p>
      <p>МОЛОДОЙ выглядит странно, обеспокоено.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Томас?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Томас Уэйк, да.
      </p>
      <p>МОЛОДОЙ, кажется, немного встревожен.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Зови меня Том.
      </p>
      <p>СТАРИК наливает еще по одной.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        За моего друга Тома и за то, чтобы свалить<br/>
        с этого проклятого камня!
      </p>
      <p>
        Они пьют, проливая немного ликера себе на подбородок.<br/>
        МОЛОДОЙ отвлекается от всего, что, казалось, его беспокоило.<br/>
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – НОЧЬ</p>
      <p>
        МОЛОДОЙ спотыкается, раздеваясь и направляется<br/>
        к кровати.
      </p>
      <p>Он бросает одежду тут и там.</p>
      <p>Изо всех сил пытается снять ботинки. Не может. Слишком пьян.</p>
      <p>Он сидит и дышит.</p>
      <p>Пытается снова. Снимает один.</p>
      <p>
        Он пробует другой... бесполезно... тянет сильнее, ботинок<br/>
        слетает, но сила настолько велика, что МОЛОДОЙ ударяется головой<br/>
        о лампу, висящую на стене...
      </p>
      <p>
        Вместе с лампой он падает на пол. Теряет сознание,<br/>
        штаны спущены до лодыжек. Его волосы впитывают керосин<br/>
        из разбитой лампы.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – УТРО</p>
      <p>МОЛОДОЙ просыпается.</p>
      <p>У него сильное похмелье. Хочется умереть.</p>
      <p>Нужна вода...</p>
      <p>Кувшин... таз... оба пусты. Он опрокинул их</p>
      <p style={{ textAlign: "right" }}>44.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page43" />
        <ForwardLink href="/page45" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710315154/the-lighthouse-script/nmszjxmfn55ijumrbplq.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page45;
